import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Form, Modal } from 'react-bootstrap';
import { handleDelete, handleSubmit as modalSubmit } from '../../components/modals/ModalHelpers';
import DynModal from '../../components/modals/DynModal';
import ButtonCard from '../../components/cards/ButtonCard';
import ButtonGroup from '../../components/modals/ButtonGroup';
import InputField from '../../components/form/InputField';
import PagedTable from '../../components/table/PagedTable';
import Bivema from '../../common/Bivema';

const columnsTargetGroup = [
  { title: 'Name', name: 'name' },
  { title: 'Beschreibung', name: 'description' },
  { title: 'Edit', name: '_links.self.href' },
];

const defaultTargetGroup = {
  name: '', description: '',
};

const targetGroupValidationSchema = Yup.object().shape({
  name: Yup.string()
    .max(100, 'Darf maximal 100 Zeichen lang sein.')
    .required('Bitte geben Sie einen Namen ein.'),
  description: Yup.string()
    .nullable(true)
    .max(255, 'Darf maximal 255 Zeichen lang sein.'),
});

const TargetGroupOverview = () => {
  const [update, setUpdate] = useState(false);
  const [selfLink, setSelfLink] = useState();
  const [showDynModal, setShowDynModal] = useState(false);
  const [classNameDynModal, setClassNameDynModal] = useState('dynModal');

  const [targetGroup, setTargetGroup] = useState({
    ...defaultTargetGroup,
  });

  // needed for formik, to pass it to the modal and set the values
  const formikRef = useRef();

  // set Tab Title
  useEffect(() => {
    document.title = 'Zielgruppe | Stammdaten';
  }, []);

  useEffect(() => {
    if (targetGroup._links !== undefined) {
      setSelfLink(targetGroup._links.self.href);
    }

    // sets formik values
    if (formikRef.current && targetGroup !== formikRef.current.values) {
      formikRef.current.setValues(targetGroup);
    }
  }, [targetGroup]);
  return (
    <div className="container-fluid">
      <ButtonCard title="Zielgruppe" className="mt-2" setShowDynModal={setShowDynModal}>
        <DynModal
          className={classNameDynModal}
          headerTitle="Zielgruppe"
          setEntity={setTargetGroup}
          defaultEntity={defaultTargetGroup}
          settersToReset={[setSelfLink]}
          formikRef={formikRef}
          show={showDynModal}
          setShow={setShowDynModal}
          modalBody={(
            <Formik
              innerRef={formikRef}
              initialValues={targetGroup}
              onSubmit={(values, submitProps) => modalSubmit(
                values,
                submitProps,
                setUpdate,
                Bivema.TARGET_GROUPS,
                selfLink,
              )}
              validateOnChange={false} // because at the moment on change validates all fields
              validationSchema={targetGroupValidationSchema}
            >
              {({
                errors, touched, handleSubmit, handleReset, handleChange, values,
              }) => (
                <Form onSubmit={handleSubmit} onReset={handleReset}>
                  <Modal.Body>
                    <Form.Group controlId="targetGroup-group">
                      <InputField
                        value={values.name}
                        handleChange={handleChange}
                        touched={touched.name}
                        errorDescription={errors.name}
                        fieldName="name"
                        placeholder="Name*"
                        props={{ className: 'mb-2' }}
                      />
                      <InputField
                        value={values.description}
                        handleChange={handleChange}
                        touched={touched.description}
                        errorDescription={errors.description}
                        fieldName="description"
                        placeholder="Beschreibung"
                        props={{ className: 'mb-2' }}
                      />
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer>
                    <ButtonGroup
                      handleDelete={() => handleDelete(selfLink, setUpdate)}
                      selfLink={selfLink !== undefined}
                      setShowDynModal={setShowDynModal}
                      setClassNameDynModal={setClassNameDynModal}
                    />
                  </Modal.Footer>
                </Form>
              )}
            </Formik>
          )}
        />
        <PagedTable
          entityName={Bivema.TARGET_GROUPS}
          columns={columnsTargetGroup}
          pageSize={10}
          setShowDynModal={setShowDynModal}
          setEntity={setTargetGroup}
          setUpdate={setUpdate}
          update={update}
        />
      </ButtonCard>
    </div>
  );
};

export default TargetGroupOverview;
